// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
const { typePolicies } = require('@shared-ui/apollo-type-policies');

module.exports = {
  ...typePolicies,
  FlightsSearchResponse: {
    merge: true
  },
  MultiItemSessionMutations: {
    merge: true
  }
};
